import React, { useState, useEffect, useContext } from "react";
import "./CompanyPlanDetails.css";
import api from "../../utils/api";
import LoadingIcon from "../../components/LoadingIcon";
import Benefits from "./components/PaymentPlan/Benefits"
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getPeriodLabel, formatCurrency } from "../../utils/period";
import { AuthContext } from "../../providers/AuthProvider";

const CompanyPlanDetails = ({ company }) => {
  const { user } = useContext(AuthContext);
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [benefits, setBenefits] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        setLoading(true);
        const { data } = await api.get(`/companies/companies/${user.id}`);

        if (data?.data?.attributes?.subscription) {
          const subscription = data.data.attributes.subscription;

          setSubscriptionData(subscription);

          // Extract benefits separately
          const planBenefits = subscription?.paymentPlan?.benefits || [];
          setBenefits(planBenefits);
        } else {
          setBenefits([]);
        }
      } catch (error) {
        toast.error("Error fetching company data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (user?.id) {
      fetchCompanyData();
    }
  }, [user?.id]);

  if (loading) {
    return (
      <div className="companyPlanDetails" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1 }}>
        <LoadingIcon />
      </div>
    );
  }

  if (!subscriptionData) {
    return (
      <div className="companyPlanDetails">
        <div className="containerInfoPlan">
          <div className="groupInfoPlan">
            <div className="label">Meu Plano:</div>
            <div className="value">Nenhum plano ativo</div>
          </div>
          <div
            className="buttonAlterPlan"
            onClick={() => {
              navigate("/companies/settings/change-plan");
            }}
          >
            Escolher Plano
          </div>
        </div>
      </div>
    );
  }

  const { paymentPlan: plan, amount, period, status, daysUntilRenewal, autoRenew, trialEndsAt, scheduledChange } = subscriptionData;

  const isTrialOrAdmin = plan?.trial || plan?.admin;

  return (
    <div className="companyPlanDetails">
      <div className="containerInfoPlan">
        <div className="groupInfoPlan">
          <div className="label">Meu Plano:</div>
          <div className="value">{plan?.name || "N/A"}</div>
        </div>

        {!isTrialOrAdmin && (
          <>
            <div className="groupInfoPlan">
              <div className="label">Valor:</div>
              <div className="value">
                {amount
                  ? formatCurrency(amount)
                  : "N/A"
                }
              </div>
            </div>

            <div className="groupInfoPlan">
              <div className="label">Período:</div>
              <div className="value">
                {getPeriodLabel(period)}
              </div>
            </div>
          </>
        )}

        {daysUntilRenewal !== null && (
          autoRenew ? (
            <div className="groupInfoPlan">
              <div className="label">Próxima Renovação:</div>
              <div className="value">
                {daysUntilRenewal > 0
                  ? `Em ${daysUntilRenewal} dias`
                  : daysUntilRenewal === 0
                    ? 'Hoje'
                    : `Atrasado há ${Math.abs(daysUntilRenewal)} dias`
                }
              </div>
            </div>
          ) : (
            <div className="groupInfoPlan">
              <div className="label">Encerramento da Assinatura:</div>
              <div className="value">
                {daysUntilRenewal > 0
                  ? `Em ${daysUntilRenewal} dias`
                  : daysUntilRenewal === 0
                    ? 'Hoje'
                    : `Encerrada há ${Math.abs(daysUntilRenewal)} dias`
                }
              </div>
            </div>
          )
        )}

        {scheduledChange && (
          <div className="groupInfoPlan">
            <div className="label">Mudança de Plano:</div>
            <div className="value">
              Sua assinatura será alterada para o plano <strong>{scheduledChange.planName}</strong> no dia <strong>{new Date(scheduledChange.effectiveAt).toLocaleDateString('pt-BR')}</strong>
            </div>
          </div>
        )}

        {trialEndsAt && (
          <div className="groupInfoPlan">
            <div className="label">Teste Termina:</div>
            <div className="value">
              {new Date(trialEndsAt).toLocaleDateString('pt-BR')}
            </div>
          </div>
        )}

        {!isTrialOrAdmin && (
          <div className="groupInfoPlan">
            <div className="label">Status:</div>
            <div className="value">
              <span className={`status-badge status-${status}`}>
                {status === 'active' ? 'Ativo' : status}
              </span>
            </div>
          </div>
        )}

        <div
          className="buttonAlterPlan"
          onClick={() => {
            navigate("/companies/settings/change-plan");
          }}
        >
          Alterar Plano
        </div>
      </div>

      <div className="containerBenefits">
        <div className="benefitsTitle">Benefícios:</div>
        <div className="benefitsList">
          {benefits && benefits.length > 0 ? (
            <Benefits benefits={benefits} />
          ) : (
            <div className="noBenefits">Nenhum benefício disponível</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CompanyPlanDetails;

